import React from 'react';

// Etoiles pleines, demies et vides, dessinees en SVG pour rester nettes
// a toutes les tailles et suivre les couleurs du site.

function Etoile({ remplissage, taille, id }) {
  const cle = `etoile-${id}`;
  return (
    <svg width={taille} height={taille} viewBox="0 0 24 24" aria-hidden="true" className="shrink-0">
      <defs>
        <linearGradient id={cle}>
          <stop offset={`${remplissage * 100}%`} stopColor="currentColor" />
          <stop offset={`${remplissage * 100}%`} stopColor="currentColor" stopOpacity="0.22" />
        </linearGradient>
      </defs>
      <path
        d="M12 2.4l2.9 5.9 6.5.95-4.7 4.58 1.11 6.47L12 17.25 6.19 20.3l1.11-6.47L2.6 9.25l6.5-.95L12 2.4z"
        fill={`url(#${cle})`}
      />
    </svg>
  );
}

export default function NoteEtoiles({ note, taille = 18, classe = '' }) {
  const valeur = Math.max(0, Math.min(5, Number(note) || 0));
  return (
    <span className={`inline-flex items-center gap-0.5 ${classe}`} role="img" aria-label={`${valeur} sur 5`}>
      {[0, 1, 2, 3, 4].map((i) => (
        <Etoile
          key={i}
          id={`${i}-${Math.round(valeur * 10)}-${taille}`}
          taille={taille}
          remplissage={Math.max(0, Math.min(1, valeur - i))}
        />
      ))}
    </span>
  );
}
